import { KeywordQuery } from "../keyword-query";

export default class CommonQuery extends KeywordQuery {
	constructor() {
		super();
		this.queryData["keyword"] = null;
	}
}
